import { TFunction } from "i18next";
import { Actions } from "@/components/PageHeader/actions/types";

import {
  ANALYSIS_PROVIDERS_ACTIONS,
  COMPANIES_ACTIONS,
  DRIVERS_ACTIONS,
  INTEGRATIONS_ACTIONS,
  INTEGRATIONS_API_ACTIONS,
  PossibleResourceActions,
  TABLE_NAMES,
  USERS_ACTIONS,
  VEHICLES_ACTIONS
} from "../../../shared";

export const getActionForSelectionDialogTitle = (
  resourceAction: PossibleResourceActions,
  t: TFunction<"translation", undefined>
) => {
  switch (resourceAction) {
    case DRIVERS_ACTIONS.BulkQuickScheduleDownload:
      return t("Dialog##create quick schedule");

    case VEHICLES_ACTIONS.QuickScheduleDownload:
      return t("Schedules##quick schedule##title");

    case VEHICLES_ACTIONS.RemoveSchedules:
    case DRIVERS_ACTIONS.RemoveSchedules:
      return t("Dialog##remove schedules");

    case VEHICLES_ACTIONS.MoveVehicles:
      return t("Dialog##move vehicles");

    case VEHICLES_ACTIONS.Activate:
      return t("Dialog##activate vehicles##title");

    case VEHICLES_ACTIONS.Deactivate:
      return t("Dialog##deactivate vehicles##title");

    case VEHICLES_ACTIONS.DeleteVehicle:
      return t("Dialog##delete vehicles");

    case DRIVERS_ACTIONS.DeleteDriver:
      return t("Dialog##delete drivers");
    case COMPANIES_ACTIONS.DeleteCompany:
      return t("Dialog##delete companies");
    case USERS_ACTIONS.DeleteUser:
      return t("Dialog##delete users");
    case INTEGRATIONS_ACTIONS.DeleteIntegration:
    case ANALYSIS_PROVIDERS_ACTIONS.Delete:
      return t("Dialog##delete integrations");
    case INTEGRATIONS_API_ACTIONS.DeleteCredential:
      return t("Dialog##delete api credentials");

    default:
      return "";
  }
};

export const getActionForSelectionDialogDescription = (
  resourceAction: PossibleResourceActions,
  t: TFunction<"translation", undefined>
) => {
  switch (resourceAction) {
    case VEHICLES_ACTIONS.QuickScheduleDownload:
      return t("Schedules##quick schedule##description");

    case VEHICLES_ACTIONS.AddSchedule:
      return t("Dialog##confirm add schedule");
    case VEHICLES_ACTIONS.RemoveSchedules:
      return t("Dialog##remove schedules description##vehicles");

    case VEHICLES_ACTIONS.Activate:
      return t("Dialog##activate vehicles##description");

    case VEHICLES_ACTIONS.Deactivate:
      return t("Dialog##deactivate vehicles##description");

    case VEHICLES_ACTIONS.DeleteVehicle:
      return t("Dialog##confirm delete vehicles");

    case DRIVERS_ACTIONS.BulkQuickScheduleDownload:
      return t("Schedules##confirm bulk quick schedule");

    case DRIVERS_ACTIONS.DeleteDriver:
      return t("Dialog##confirm delete drivers");
    case COMPANIES_ACTIONS.DeleteCompany:
      return t("Dialog##confirm delete companies");
    case USERS_ACTIONS.DeleteUser:
      return t("Dialog##confirm delete users");
    case INTEGRATIONS_ACTIONS.DeleteIntegration:
    case ANALYSIS_PROVIDERS_ACTIONS.Delete:
      return t("Dialog##confirm delete integrations");
    case INTEGRATIONS_API_ACTIONS.DeleteCredential:
      return t("Dialog##confirm delete api credentials");

    case DRIVERS_ACTIONS.RemoveSchedules:
      return t("Dialog##remove schedules description##drivers");
    default:
      return "";
  }
};

export const getActionForSelectionConfirmationButtonText = (
  resourceAction: PossibleResourceActions,
  t: TFunction<"translation", undefined>
) => {
  switch (resourceAction) {
    case VEHICLES_ACTIONS.DeleteVehicle:
    case DRIVERS_ACTIONS.DeleteDriver:
    case USERS_ACTIONS.DeleteUser:
    case COMPANIES_ACTIONS.DeleteCompany:
    case INTEGRATIONS_ACTIONS.DeleteIntegration:
    case INTEGRATIONS_API_ACTIONS.DeleteCredential:
    case ANALYSIS_PROVIDERS_ACTIONS.Delete:
      return t("Dialog##delete");

    case VEHICLES_ACTIONS.AddSchedule:
      return t("Dialog##add");

    case VEHICLES_ACTIONS.CreateSchedule:
    case DRIVERS_ACTIONS.BulkQuickScheduleDownload:
    case VEHICLES_ACTIONS.QuickScheduleDownload:
      return t("Dialog##create");

    case VEHICLES_ACTIONS.MoveVehicles:
      return t("Button##move");

    case VEHICLES_ACTIONS.RemoveSchedules:
    case DRIVERS_ACTIONS.RemoveSchedules:
      return t("Dialog##remove");

    case VEHICLES_ACTIONS.Activate:
      return t("Button##activate");

    case VEHICLES_ACTIONS.Deactivate:
      return t("Button##deactivate");

    default:
      return "";
  }
};

export const getPayloadObject = (
  resourceName: TABLE_NAMES | undefined,
  selectedRows: string[]
) => {
  switch (resourceName) {
    case TABLE_NAMES.Vehicles:
      return { vehicleIds: selectedRows };
    case TABLE_NAMES.Drivers:
      return { driverIds: selectedRows };
    case TABLE_NAMES.Users:
      return { userIds: selectedRows };
    case TABLE_NAMES.Companies:
      return { companyIds: selectedRows };
    case TABLE_NAMES.Integrations:
    case TABLE_NAMES.AnalysisProviders:
      return { integrationIds: selectedRows };
    case TABLE_NAMES.IntegrationsApi:
      return { ids: selectedRows };

    default:
      return {};
  }
};

export const getButtonText = (
  action: Actions,
  t: TFunction<"translation", undefined>
) => {
  switch (action) {
    case DRIVERS_ACTIONS.BulkQuickScheduleDownload:
      return t("Button##quick schedule");

    case VEHICLES_ACTIONS.QuickScheduleDownload:
      return t("Schedules##quick schedule##title");

    case DRIVERS_ACTIONS.AddSchedule:
    case VEHICLES_ACTIONS.AddSchedule:
      return t("Button##add to schedule");

    case VEHICLES_ACTIONS.CreateSchedule:
    case DRIVERS_ACTIONS.CreateSchedule:
      return t("Button##create schedule");

    case VEHICLES_ACTIONS.RemoveSchedules:
    case DRIVERS_ACTIONS.RemoveSchedules:
      return t("Button##remove schedules");

    case VEHICLES_ACTIONS.DeleteVehicle:
    case DRIVERS_ACTIONS.DeleteDriver:
    case USERS_ACTIONS.DeleteUser:
    case COMPANIES_ACTIONS.DeleteCompany:
    case INTEGRATIONS_ACTIONS.DeleteIntegration:
    case INTEGRATIONS_API_ACTIONS.DeleteCredential:
    case ANALYSIS_PROVIDERS_ACTIONS.Delete:
      return t("Button##delete");

    case VEHICLES_ACTIONS.MoveVehicles:
      return t("Button##move");

    case VEHICLES_ACTIONS.Activate:
      return t("Button##activate");

    case VEHICLES_ACTIONS.Deactivate:
      return t("Button##deactivate");

    default:
      return "";
  }
};
